(function () {
  /**
   * @ngdoc service/provider
   * @name jilLicensingAdmins
   * @description defines service to manage jil licensing admins resources
   */
  angular.module('app.core.api.jil').provider('jilLicensingAdmins', provider);

  let url;

  /* @ngInject */
  function provider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/resellers/licensing-admins`;
    }

    /* @ngInject */
    function $get($resource) {
      const service = {
        licensingAdmin: getLicensingAdminResource(),
        licensingAdminRole: getLicensingAdminRoleResource(),
        licensingAdmins: getLicensingAdminsResource(),
      };

      return service;

      ///////////

      function getLicensingAdminsResource() {
        return $resource(url);
      }

      function getLicensingAdminRoleResource() {
        return $resource(
          `${url}/:userId/role`,
          {userId: '@userId'},
          {
            update: {method: 'PUT'},
          }
        );
      }

      function getLicensingAdminResource() {
        return $resource(`${url}/:userId`, {userId: '@userId'});
      }
    }
  }
})();
